import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {runTrackingSafely} from "../../../tracking/utils/run_tracking_safely";
import {
    getAmplitudeListingFiltersAppliedEventProperties,
    IGetAmplitudeListingFiltersAppliedParams
} from "./get_amplitude_listing_filters_applied_event_properties";

export const trackAmplitudeListingFiltersApplied = (params: IGetAmplitudeListingFiltersAppliedParams) => {
    // called before onSubmit in the listing filters submit handlers, so it must never throw at them
    runTrackingSafely(
        () => trackAmplitudeEvent("listing_filters_applied", getAmplitudeListingFiltersAppliedEventProperties(params)),
        "trackAmplitudeListingFiltersApplied failed",
        params
    );
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {runTrackingSafely} from "../../../tracking/utils/run_tracking_safely";
import {
    getAmplitudeListingFiltersAppliedEventProperties,
    IGetAmplitudeListingFiltersAppliedParams
} from "./get_amplitude_listing_filters_applied_event_properties";

export const trackAmplitudeListingFiltersApplied = (params: IGetAmplitudeListingFiltersAppliedParams) => {
    // called before onSubmit in the listing filters submit handlers, so it must never throw at them
    runTrackingSafely(
        () => trackAmplitudeEvent("listing_filters_applied", getAmplitudeListingFiltersAppliedEventProperties(params)),
        "trackAmplitudeListingFiltersApplied failed",
        params
    );
};
